import React, { useEffect } from "react";
import { DatePicker, Layout, Modal, Progress, Upload, Image,Spin } from "antd";
import SideNavBar from "../../Components/SideBar/Sidebar";
import { Content } from "antd/es/layout/layout";
import Cookies from "js-cookie";
import { useState } from "react";
import Navbar from "../../Components/Support/Header";
import { Header } from "antd/es/layout/layout";
import {Select, Button} from "antd"
import axios from "axios";
import AccrualsFileTransfer from "../../Components/FileTransfer/AccrualsFileTransfer";
import { Link, Redirect } from "react-router-dom/cjs/react-router-dom.min";
import fileDownload from "js-file-download";
import { BaseUrl,FormConfig } from "../../Repository/BaseRepository";
import { LoadingOutlined, DeleteOutlined } from "@ant-design/icons";
import { ErrorMessage, SuccessMessage } from "../../Utils/Utils";

const {RangePicker} = DatePicker;

const AccrualsCrawling = () => {
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");

    //vms dropdown
    const [result, getdata] = useState([]);
    //Blur flag
    const [isloading, setloading] = useState(false);
    // Prograss bar flag
    const [showProgressbar, setShowProgressbar] = useState(false);
    var count
    var countIncrement;

    const [targetKeys, setTargetKeys] = useState([]); // selected clients list
    const [selectedKeys, setSelectedKeys] = useState([]);

  
    //Download All State for Cleints List
    const [clientsOfVMS, setClientsOfVMS] = useState([]);
    const [now, setNow] = useState(0);
    const [progressWidth, setProgressWidth] = useState(false);

    //Get Client State Variables 
    const [vmsClients, setVmsClients] = useState([]); 
    const [selectedVms, setSelectedVms] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fromDate, setFromDate] = useState()
    const [toDate, setTodate] = useState()
    const [fileList, setFileList] = useState([]);
    const [uploadSpinLoader, setUploadSpinLoader] = useState(false);
    const [manualLoadingFileName, setManualLoadingFileName] = useState('');

    //Progress Clients Count Data
    const [totalClients, setTotalClients] = useState();
    const [downloadedClients, setDownloadedClients] = useState(0);
    const [sampleVms, setSampleVms] = useState();
    const tenantName = Cookies.get("tenant_name");

    useEffect(() => {
        callClientsList();
    }, []);

    const callClientsList = async () => {
        const res = await axios (
            `${process.env.REACT_APP_BASE_URL}Home/getvmslist`,
            {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );
        const temp = res.data;
        getdata(temp);
    }

    const GetClientsListOfVms = async (vms) => {
        setTotalClients(0);
        setSelectedKeys([]);
        setTargetKeys([]);
        setSelectedVms(vms);
        const url = `${process.env.REACT_APP_BASE_URL}Accruals/getAccrualsclientslist/` + vms;
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        };
        //Api Call
        if(vms.length === 0){
            setVmsClients([]);
        } else {
            const clientResponse = await axios.get(url, config);
            setVmsClients(clientResponse.data);
        }
    }

    // -------------------------------------- Download All APIS ---------------------------------------------

    const handleClick = async () => {
        var len = 0;
        len = selectedVms.length;

        try {
            var i = 0;
            let testVms = [];

            for(i = 0 ; i < len; i ++){
                setClientsOfVMS([]);
                setShowProgressbar(false);
                setDownloadedClients(0);
                countIncrement = 0;
                setNow(parseInt(countIncrement));
                testVms = selectedVms[i];
                setSampleVms(testVms);
                try{
                    const resp = await axios.get(
                        `${process.env.REACT_APP_BASE_URL}Accruals/getAccrualsclientslist/` + testVms,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        }
                    );
                    clientsOfVMS.push(resp.data);
                    let length = resp.data.length;
                    count = 100 / length;
                    setTotalClients(length);
                    let j = 0;
                    let eachCLient = [];
                    for(j = 0; j < length; j++){
                        setloading(true);
                        setShowProgressbar(true);
                        setProgressWidth(true);
                        eachCLient = [];
                        eachCLient.push(clientsOfVMS[i][j]);
                        try{
                            const url = `${process.env.REACT_APP_BASE_URL}Accruals/DownloadWithDatesAccruals?VMS=` + selectedVms + `&fromDate=` + fromDate + `&toDate=` + toDate + `&userLogin=` + userLogin;
                            const res = await axios.post(url, JSON.stringify(eachCLient),
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${jwtToken}`,
                                    },
                                }
                            );
                            callNowPercentage(count, j);

                        } catch(err) {
                            console.log("*** Error Message *** :" + err);
                        }
                    }
                    
                } catch (err){
                    console.log("*** Error Message *** :" + err);
                }

            }
            setloading(false);
            setShowProgressbar(false);
            setIsModalOpen(true);
            info();
        } catch(err){
            console.log("*** Error Message  *** : " +err );
        }
    }

    const DownloadForSelected = async () => {

        try{
            setShowProgressbar(false);
            setDownloadedClients(0);
            countIncrement = 0;
            setNow(parseInt(countIncrement));
            let length = targetKeys.length;
            count = 100/ length;
            setTotalClients(length);
            let j  = 0;
            let eachCLient = [];
            for(j = 0; j < length; j++){
                setloading(true);
                setShowProgressbar(true);
                setProgressWidth(true);
                eachCLient = [];
                eachCLient.push(targetKeys[j]);
                try{
                    await DownloadEachCLient(eachCLient);
                    callNowPercentage(count, j);

                } catch (err){
                    console.log(" *** Error Message *** :" + err );
                }
            }
            setloading(false);
            setShowProgressbar(false);
            info()
        }catch(err){
            console.log("*** Error Message *** :" + err);
        }
    }

    const callNowPercentage = async (count, int) => {
        setProgressWidth(true);
        countIncrement = countIncrement + count;
        setNow(parseInt(countIncrement));
        setDownloadedClients(int + 1);
    }
    if(jwtToken === undefined){
        return <Redirect to="/" />
    }

    const info =  () => {
        Modal.info({
            icon : null,
            title : "Finished processing your request, Click OK to download the files",
            onOk() {
                downloadFiles();
                setIsModalOpen(false);
                setloading(false);
            },
        });
    };

    //API to Download  Reports for selected clients 
    const DownloadEachCLient = async (eachCLient) => {
        const url = `${process.env.REACT_APP_BASE_URL}Accruals/DownloadWithDatesAccruals?VMS=` + selectedVms + `&fromDate=` + fromDate + `&toDate=` + toDate + `&userLogin=` + userLogin;
        const config = {
            headers : {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        };

        const DownloadResponse = await axios.post(url, JSON.stringify(eachCLient), config);

    }

    const progressCloseButton = () => {
        setShowProgressbar(false);
    };
    const downloadFiles = async (e) => {
        setShowProgressbar(false);
        try{
            const response = await axios ({
                url:
                    `${process.env.REACT_APP_BASE_URL}Accruals/DownloadZipFile_Accruals?filename=` + userLogin,
                method: "GET",
                responseType: "blob",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },    
            });
            fileDownload(response.data, "Accruals.zip");
            DeleteFiles();
            setIsModalOpen(false);
        }
        catch(err){
            DeleteFiles();
            setIsModalOpen(false);
        }
    }

    const DeleteFiles = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}Accruals/deleteFiles_accruals?userLogin=` + userLogin,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        }).catch((err) => alert(err));
    };

    const callCalendar = (e) => {
        if(e !== null) {
            if(e[0] !== null && e[1] !== null){
                const sample = new Date(e[0]);
                const sample1 = new Date(e[1]);
                var newD = parseInt(sample.getMonth() + 1 ) + '/' + parseInt(sample.getDate()) + '/' + parseInt(sample.getFullYear());
                var newD1 = parseInt(sample1.getMonth() + 1) + '/' + parseInt(sample1.getDate()) + '/' + parseInt(sample1.getFullYear());
                setFromDate(newD);
                setTodate(newD1); 
            }
        }
        else{
            setFromDate();
            setTodate();
        }
    }
    const handleUpload = async (options) => {
        try {
            setUploadSpinLoader(true)
            const { file, onSuccess, onError } = options;
            const updatedFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("file", file);
            setFileList([])
            setManualLoadingFileName(file.name);
            const response = await axios.post(`${BaseUrl}Home/manualuploadFileforAccruals?userLogin=${userLogin}`, formData, FormConfig)
            if (response.data.IsSuccess === true) {
                onSuccess(file);
                SuccessMessage(`${file.name} file uploaded successfully.`);
                updatedFile.status = "done";
                setFileList([updatedFile])
                setUploadSpinLoader(false)
                setManualLoadingFileName('')
            }
            else {
                onError(file);
                if (response.data.Message === "FileName is Invalid") {
                    ErrorMessage(`${file.name} file name is invalid`);
                }
                else {
                    ErrorMessage(`${file.name} file upload failed`);
                }
                updatedFile.status = "error";
                setFileList([updatedFile]);
                setUploadSpinLoader(false)
                setManualLoadingFileName('')
            }
        }
        catch {
            setUploadSpinLoader(false)
            ErrorMessage("Cannot able to upload, try again later")
            setManualLoadingFileName('')
        }
    }
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (fileList.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", marginTop: "10px", }}>{fileExists ? fileList[0].file.name : null}<DeleteOutlined onClick={() => setFileList([])} /></div>

        </>;
    };

  return (
    <>
      <Layout 
        className={isloading ? "blur" : ""}
        style={{backgroundColor: "white", height : "100vh", display:"flex", overflow:"hidden"}}
      >
        <SideNavBar/>
            <Layout
                className="whole-layout"
                style={{backgroundColor: "white", overflow:"hidden"}}
            >
                <Header className="audit-header">
                    <Navbar />
                </Header>

                <Content className="audit-content">
                    <div className="image-content">
                        <div className="select-clients-elements">
                            <div style={{ margin: 10 }}>
                                <Select
                                    className="select-elements"
                                    mode="multiple"
                                    size="medium"
                                        // style={{ width: 160, height:28.32 }}
                                    placeholder="Select VMS"
                                    allowClear
                                    maxTagCount="responsive"
                                    onChange={(newValue) => {
                                            GetClientsListOfVms(newValue);
                                    }}
                                    >
                                        {result
                                            ? result.map((item, index) => {
                                                return (
                                                    <Select.Option key={index} value={item}>
                                                        {item}
                                                    </Select.Option>
                                                );
                                            })
                                            : null}
                                    </Select>
                            </div>
                            <RangePicker style={{ width: 160 }} format={"MM-DD-YYYY"} className="rage-elements"
                                    onCalendarChange={(e) => callCalendar(e)} />
                            <div className="button-container">
                                    <Button
                                        className="downloadall-button"
                                        onClick={handleClick}
                                        disabled={
                                            selectedVms.length === 0 || (fromDate === undefined && toDate === undefined)
                                            && (fromDate !== undefined && toDate !== undefined)
                                            || (fromDate === undefined && toDate === undefined)
                                        }
                                    >
                                        Download All
                                    </Button>
                            </div>
                        </div>
                        <div className="filename-label">
                            <span className="file-para">
                                <span style={{fontWeight:500}}>Note :&nbsp;&nbsp;</span>Filename should be "VMSName_ClientName" format{" "}
                            </span>
                        </div>
                        <br></br>
                        <div className="ten-manual-upload">
                            <div className="inputfile-upload">
                                <Upload
                                    className="hr-upload-file"
                                    name="file"
                                    customRequest={handleUpload}
                                    itemRender={itemRender}
                                    fileList={fileList}
                                    accept=".xls,.xlsx"
                                    onRemove={() => setFileList([])}
                                >
                                    <div className="hr-content-file">
                                        <span className="hrfile-name">Manual Upload</span>
                                        {uploadSpinLoader ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7, color: "#3B52DF" }} spin />} />

                                        : <Image src="/Images/uploadimg (2).png"
                                        style={{
                                            border: "none",
                                            width: 19,
                                            height: 17,
                                        }}
                                        showPreviewIcon={false}
                                        preview={false} />}
                                    </div>
                                </Upload>
                                {manualLoadingFileName.length > 0 ? <div style={{ width: 'fit-content', wordBreak: 'break-all', marginBottom: 2, color: "#3B52DF" }}>{manualLoadingFileName}</div> : null}
                            </div>
                        </div>
                    </div>
                    <div className="tranfer-otherpages-class">
                        <div className="otherpage-buttons">
                            <Button className="currentpage-button">Selected Crawling</Button>
                            <Link to={`/${tenantName}/accrualsmasterfile`}><Button className="page-button">Master File</Button></Link>
                        </div>
                        
                        <div className="transfer-footers">
                                <AccrualsFileTransfer
                                    targetKeys={targetKeys}
                                    setTargetKeys={setTargetKeys}
                                    selectedKeys={selectedKeys}
                                    setSelectedKeys={setSelectedKeys}
                                    clientsList={vmsClients}
                                    Vms={selectedVms}
                                    //frequency={outputFrequency}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                />
                                <div className="footer-buttons">
                                    <Button
                                        className=" dwnselected-button"
                                        onClick={() => DownloadForSelected()}
                                        disabled={
                                            targetKeys.length === 0 || (fromDate === undefined && toDate === undefined)
                                            && (fromDate !== undefined && toDate !== undefined)
                                            || (fromDate === undefined && toDate === undefined)
                                        }
                                    >
                                        Download selected clients
                                    </Button>
                                </div>
                            </div>
                    </div>
                </Content>
            </Layout>
      </Layout>
      {showProgressbar && (
        <div className="popup">
            <div className="popup-inner ">
                <div className="name-progress">
                    <div className="download-head">Downloading...</div>
                    <div className="progressbar">
                        <div className="progress-div">
                            {progressWidth && (
                                <div 
                                    className="filled-progressbar" 
                                    style={{width: now + "%"}}
                                >
                                    <span style={{fontSize: 12}}>{now}%</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="Vms-status">
                        {downloadedClients} out of {totalClients} in {" "}
                        {selectedVms.length > 1 ? sampleVms : selectedVms}
                    </div>
                    <button className="close-btn" onClick={progressCloseButton}>
                        Ok
                    </button>
                </div>
            </div>
        </div>
      )}
    </>
  );
};

export default AccrualsCrawling;
